<template>
    <component :is="isRegistrationAllowed ? 'a' : 'div'"
               :href="event.registrationLink"
               target="_blank"
               @click.prevent.stop="openRegLink"> <!-- Das scheint ziemlich dumm zu sein, aber muss so sein! Weiteres siehe openRegLink Methode -->
        <base-button :disabled="!isRegistrationAllowed" :type="registrationButtonType">
            <span v-if="event.occupancy !== 'full'">{{ $t('iFrame.registration') }}</span>
            <span v-else-if="event.allowRegistrationIfFullyBooked">{{ $t('iFrame.waitingList') }}</span>
            <span v-else>{{ $t('iFrame.bookedOut') }}</span>
        </base-button>
    </component>
</template>

<script>
export default {
    name: "EventEntryRegistrationButton",
    props: {
        event: {
            required: true,
            type: Object
        }
    },
    computed: {
        registrationButtonType() {
            switch (this.event.occupancy) {
                case 'full':
                    return 'danger'
                case 'few':
                    return 'warning'
                case 'free':
                    return 'success'
                default:
                    return 'success'
            }
        },
        isRegistrationAllowed() {
            if (this.event.allowRegistrationIfFullyBooked) return true
            return this.event.occupancy !== 'full';
        }
    },
    methods: {
        /*
        Wir benutzen hier window.open anstatt direkt den Hyperlink zu verwenden. Das scheint erst mal keinen Unterschied
        zu machen, jedoch hat Safari einen Bug der jegliche Cookies in der aufgerufenen Seite blockiert,
        wenn die Seite durch einen Klick auf einen Hyperlink in einem I-Frame direkt aufgerufen wird.
        Dies passiert nicht, wenn man window.open verwendet.
         */
        openRegLink(){
            window.open(this.event.registrationLink, '_blank')
        }
    }
}
</script>

<style scoped>

</style>
